import { createFileRoute } from "@tanstack/react-router";
import { KostenPage, kostenHead } from "../components/KostenPage";
import { kostenGuides } from "../lib/kosten-guides";

export const Route = createFileRoute("/kozijnen-kosten")({
  head: () => kostenHead(kostenGuides.kozijnen),
  component: () => <KostenPage guide={kostenGuides.kozijnen} />,
});
